import {useMutation} from '@tanstack/react-query'
import api from 'src/services/api'

type ExportDetectionsDTO = {
  fileType: 'pdf' | 'csv'
  filter: {
    cameraIds?: Array<number>
    clientIds?: Array<number>
    companyIds: Array<number>
    listId?: Array<number>
    faceIds?: Array<number>
  }
  start?: string
  end?: string
}

export default function useExportFacialDetections() {
  const mutation = useMutation({
    mutationFn: async (data: ExportDetectionsDTO) => {
      return await api.reports.getFacialDetectionsReport(data)
    },
  })

  return mutation
}
